import { createSelector } from '@ngrx/store';

import { IAppState } from '../state/app.state';
import { IMenuState } from '../state/menu.state';

const menuState = (state: IAppState) => state.menu;

export const selectMenu = createSelector(
  menuState,
  (state: IMenuState) => state.menu
);

export const selectDateMenu = createSelector(
    menuState,
    (state: IMenuState) => state.dateMenu
);
